// ==============================|| OVERRIDES - INPUT LABEL ||============================== //

export default function InputLabel(theme) {
  const pinnedOutlinedLabel = {
    background: theme.vars.palette.background.paper,
    padding: '0 8px',
    marginLeft: -6,
    top: 2,
    lineHeight: '1rem',
    transform: 'translate(14px, -9px) scale(0.75)',
    maxWidth: 'calc(133% - 32px)'
  };

  return {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: theme.vars.palette.grey[600]
        },
        outlined: {
          lineHeight: '1rem',
          top: -4,
          '&.MuiInputLabel-sizeSmall': {
            lineHeight: '1em'
          },
          '.MuiFormControl-root:not(:has(.MuiSelect-select)):not(:has(.MuiAutocomplete-inputRoot)) &:not(.MuiInputLabel-shrink)':
            pinnedOutlinedLabel,
          '&.MuiInputLabel-shrink': {
            ...pinnedOutlinedLabel
          }
        }
      }
    }
  };
}
